export * from '../src/components/wui-shimmer/index.js';
//# sourceMappingURL=wui-shimmer.js.map